import { ITypedStock, StockType } from "../omnia";
import { IStocksModuleContext } from "../types";


export class StockEditCmd {

    constructor(private context: IStocksModuleContext) {
    }

    public stock: ITypedStock;
    public stockType: StockType;
    public duplicate: boolean;

    public createStock(stockType: StockType): ng.IPromise<any> {
        return this.editInternal(null, stockType, false);
    }

    public editStock(stock: ITypedStock, duplicate: boolean): ng.IPromise<any> {
        return this.editInternal(stock, stock.StockType, duplicate);
    }

    private editInternal(stock: ITypedStock, stockType: StockType, duplicate: boolean): ng.IPromise<any> {

        this.stock = stock;
        this.stockType = stockType;
        this.duplicate = duplicate;

        var context = this.context.startComponent({ component: "omnia-stocks-edit", execArguments: this });

        if (context) {
            return context.result;
        }

    }
}
